import React, { useContext, useEffect } from 'react';
import { PROMOTION_PREFERENCE } from '../../utils/Constants';
import CustomRadioButton from '../../components/CustomRadioButton';
import { promotionpreferenceItems, tooltips } from '../../utils/ABHelper';
import { ABContext } from '../../contexts/ABContext';
import { TPayload } from '../../types/ab';
import OverlayIcon from 'Components/GMS/Rules/Components/OverlayIcon';

type PreferenceKey = 'Auto-promote Control' | 'Auto-promote Winner' | 'Run Indefinitely';

const preferenceMapping: Record<PreferenceKey, Partial<TPayload>> = {
    'Auto-promote Control': { model_to_promote: 'CONTROL', is_auto_stop: true },
    'Auto-promote Winner': { model_to_promote: 'WINNER', is_auto_stop: true },
    'Run Indefinitely': { model_to_promote: 'INDEFINITELY', is_auto_stop: false },
};

const labelMapping: Record<string, PreferenceKey> = {
    'CONTROL': 'Auto-promote Control',
    'WINNER': 'Auto-promote Winner',
    'INDEFINITELY': 'Run Indefinitely',
};

const PromotionPreference = () => {
    const abContext = useContext(ABContext);

    useEffect(() => {
        if (abContext?.setPayload && !abContext?.payload?.model_to_promote) {
        abContext.setPayload((prevPayload: TPayload) => ({
            ...prevPayload,
            model_to_promote: 'CONTROL',
            is_auto_stop: true,
        }));
        }
    }, []);

    const handlePreferenceChange = (uiLabel: string) => {
        const pref = preferenceMapping[uiLabel as PreferenceKey] || preferenceMapping['Auto-promote Control'];
        abContext?.setPayload?.((prevPayload: TPayload) => ({
        ...prevPayload,
        ...pref,
        }));
    };

    const selectedLabel =
        labelMapping[abContext?.payload?.model_to_promote] || 'Auto-promote Control';

    return (
        <section>
        <div className="tw-flex tw-items-center tw-gap-2">
            <label className="text-caption-style tw-text-[#747593]">
            {PROMOTION_PREFERENCE}
            </label>
            <OverlayIcon
                placement="right"
                message={
                    <div>
                    <p className="tw-font-medium">{tooltips["Choose_promotion_preference"]}</p>
                    <ul className="tw-list-disc tw-pl-5 tw-space-y-1">
                        <li>
                        <span className="tw-font-medium tw-text-gray-800">Auto-promote Control:</span>
                        The control model will automatically be promoted.
                        </li>
                        <li>
                        <span className="tw-font-medium tw-text-gray-800">Auto-promote Winner:</span>
                        The model with the best performance will be promoted.
                        </li>
                        <li>
                        <span className="tw-font-medium tw-text-gray-800">Run Indefinitely:</span>
                        The test continues until you manually stop it.
                        </li>
                    </ul>
                    <p className="tw-mt-3">
                        <span className="tw-font-medium tw-text-gray-800">Note:</span>
                        You can always manually stop the test or promote any model at any time, regardless of this setting.
                    </p>
                    </div>
                }
            />
        </div>
        <CustomRadioButton
            list={promotionpreferenceItems}
            showOverlayIcon={false}
            selectedItem={selectedLabel}
            setSelectedItem={handlePreferenceChange}
        />
        </section>
    );
};

export default PromotionPreference;
